module.exports = __webpack_public_path__ + "static/media/03_tn.ee2560f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/03_tn.jpg
// module id = 312
// module chunks = 0